import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import '../styles/useroptions.css'
import {useLocation} from 'react-router-dom';

const UserOptions = props => {
    const {pathname} = useLocation();
  const translations = useSelector(state => state.lang_reduse.lang);
  const rowRef = useRef(null);
  const [indicator, setIndicator] = useState({left: 0, top: 0, width: 0, height: 0, ready: false});
  const isWatch = pathname.includes('/watch');

  useEffect(() => {
    const row = rowRef.current;
    if (!row) return;

    const move = () => {
      const active = row.querySelector('.color');
      if (!active) return;
      setIndicator({
        left: active.offsetLeft,
        top: active.offsetTop,
        width: active.offsetWidth,
        height: active.offsetHeight,
        ready: true
      });
    };

    move();
    const frame = requestAnimationFrame(move);
    const observer = new ResizeObserver(move);
    observer.observe(row);
    window.addEventListener('resize', move);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
      window.removeEventListener('resize', move);
    };
  }, [props.isType, props.Visted, pathname, translations]);

  return(
 <div ref={rowRef} className={props.Visted?"UserOptionsVisted":isWatch?"userOptionsWatch":"UserOptions"}>
  {!isWatch && (
    <span
      className={`userOptionsIndicator${indicator.ready ? ' isReady' : ''}`}
      style={{
        transform: `translate3d(${indicator.left}px, ${indicator.top}px, 0)`,
        width: indicator.width,
        height: indicator.height
      }}
    />
  )}
            <div onClick={()=>{props.setType('l');}} className={props.isType === 'l'? 'color':''}><p>{translations.longs}</p></div>
          {!props.watch &&<div onClick={()=>{props.setType('i');}} className={props.isType === 'i'? 'color':''}><p>{translations.images}</p></div>}
{!props.watch &&  <div onClick={()=>{props.setType('s'); }} className={props.isType === 's'? 'color':''}><p>{translations.shorts}</p></div>}
  {!props.watch &&   <div onClick={()=>{props.setType('m'); }} className={props.isType === 'm'? 'color':''}><p>{translations.movies}</p></div>}
    {props.watch &&   <div onClick={()=>{props.setType('all'); }} className={props.isType === 'all'? 'color':''}><p>{translations.all}</p></div>}

    </div>
  )
}
export default UserOptions
